export default __webpack_public_path__ + "static/media/php.9c3759d4.png";